var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30013 1.2681C2.77257 1.96553 1.81416 3.23388 1.17046 4.08654L0 5.63689L4.38412 5.62079L8.7683 5.6047L9.7622 3.69472C10.3088 2.64423 10.965 1.3832 11.2204 0.892368L11.6848 0H7.97209H4.25942L3.30013 1.2681ZM12.3333 2.80391L10.8847 5.6047L16.1702 5.62073C19.0772 5.62949 21.4657 5.62661 21.478 5.61428C21.4903 5.602 20.7868 4.34079 19.9145 2.81162L18.3287 0.0313115L16.0553 0.0172215L13.782 0.00319433L12.3333 2.80391ZM20.4984 0.0259261C20.4984 0.040204 21.2125 1.30123 22.0855 2.82827L23.6726 5.6047L27.8363 5.62079L32 5.63689L30.8295 4.08654C30.1858 3.23388 29.2274 1.96553 28.6998 1.2681L27.7405 0H24.1194C22.1278 0 20.4984 0.0116482 20.4984 0.0259261ZM1.19957 8.87671C1.85759 9.6258 5.19489 13.4297 8.6158 17.3298C12.0367 21.2298 14.8443 24.4121 14.8548 24.4015C14.8701 24.3863 9.46112 9.58309 8.83897 7.93738L8.67915 7.51468H4.34114H0.00312388L1.19957 8.87671ZM10.7712 7.7182C10.817 7.83011 12.0046 11.0691 13.4102 14.916C14.8158 18.7628 15.9777 21.8983 15.9923 21.8837C16.0068 21.8692 17.3744 18.6302 19.0314 14.686L22.0442 7.51468H16.366H10.6877L10.7712 7.7182ZM20.5296 15.9098C18.5709 20.5256 16.959 24.3292 16.9476 24.3624C16.9361 24.3956 16.9521 24.4227 16.9832 24.4227C17.0143 24.4227 19.7368 21.3731 23.0331 17.6457C26.3295 13.9184 29.695 10.1141 30.5118 9.1917L31.9971 7.51468L28.0439 7.51612L24.0908 7.51762L20.5296 15.9098Z",
    fill: "url(#paint0_linear_1093_5950)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1093_5950",
    x1: 5,
    y1: 2.28637e-7,
    x2: 19,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE7B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12D15A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDiamond);
export default __webpack_public_path__ + "static/media/GreenDiamond.eb7433770211c498c59da8b5de15141b.svg";
export { ForwardRef as ReactComponent };